import React, { useState, useEffect, useMemo } from 'react';
import { useNestedApps } from 'oasis-os-contentful';
import { FeatureLoader, useAppState } from 'oasis-os-react';
import './style.css';
import { useAuth } from 'oasis-auth';
import { isPlatform } from '@ionic/core';

const BottomNav: React.FC = () => {
  const navigation = useNestedApps('navigation');
  const [, , app] = useAppState();
  const [isMultiSelectEnabled, setIsMultiSelectEnabled] = useState(false);
  const [auth] = useAuth();
  const authenticated = (auth.authenticated && !isPlatform('hybrid')) || isPlatform('hybrid');

  useEffect(() => {
    app.registerAction('toggleBottomNav', (isEnabled: boolean) => {
      const mediaQuery = window.matchMedia('(max-width: 960px)');
      const { matches } = mediaQuery;
      matches && setIsMultiSelectEnabled(isEnabled);
      matches && isEnabled && document.body.classList.add('bottom-nav-disabled');
      !isEnabled && document.body.classList.remove('bottom-nav-disabled');
    });
  }, []);

  const OnFeatureLoader = ({
    key,
    name,
    version,
    app,
    id,
    entry,
    meta,
  }: {
    key: string;
    name: string;
    version: number;
    app: any;
    id: string;
    entry: unknown;
    meta: any;
  }) =>
    useMemo(() => {
      return (
        <FeatureLoader
          key={key}
          name={name}
          version={version}
          app={app}
          id={id}
          initial={entry}
          sharedModule="./App"
          {...meta}
        />
      );
    }, [name]);

  return (
    <>
      {authenticated && (
        <div
          className={`pwa__bottom-nav ${isMultiSelectEnabled ? 'bottom-nav-disabled' : ''}`}
          data-testid="bottom-nav"
        >
          <div className="pwa__bottom-nav__block" />
          <div className="pwa__bottom-nav__content" data-testid="bottom-nav-content">
            {navigation &&
              navigation.map(({ name, meta, entry }) => {
                if (!meta.showMobile) {
                  return null;
                }

                return (
                  <div
                    className="pwa__bottom-nav__content__ctn"
                    key={`${meta.contentId}_bottom-nav-container-${name}`}
                    style={{
                      width: `calc(100%/${
                        navigation.filter(({ meta }) => meta.showMobile === true)?.length
                      })`,
                    }}
                  >
                    <OnFeatureLoader
                      key={`${meta.contentId}_bottom-nav-${name}`}
                      name={name}
                      version={meta.version || meta.appVersion}
                      app={{ name }}
                      id={meta.contentId}
                      entry={entry}
                      meta={meta}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </>
  );
};

export default BottomNav;
